{
    "title": "Beneficiary Under Analysis",
    "subtitle": "The current beneficiary is being analyzed and will be added to the list of beneficiaries. The process used to take 10 minutes."
}